export const maskLeaderboardUserName = (name: string): string => {
    if (name === '') return '';

    return name
        .split(' ')
        .map((part) => (part.length > 1 ? part[0] + '***' : part[0]))
        .join(' ');
};
